var lib_core = require("lib-core");

/**
 * @constructor
 */
var DeleteStateMachine = function (root, model) {
    var self = this;
    this.root = root;
    this.model = model;

    lib_core.StateMachine.call(this);

    this.selectionModel = this.model.parent();

    this.addTransition("idle", "idle",
        function(cEvent){
            //For some reason, we have to explicitly check for the shift and control keys.
            // The ALT key is handled independently though.
            return ((cEvent.type() == lib_core.GuiEvents.REMOVE_BUTTON
                || cEvent.isKeyPressed( 'delete', 'backspace', 'C_delete', 'C_backspace', 'S_delete', 'S_backspace'))
                && self.selectionModel.selection.size() > 0);
        },
        function(cEvent){
            self.root.rec();
            //figure out the deletion mode
            var mode = {'special':false,'alternative':false};
            //TODO: we should use keymapping for this
            //TODO: should the shift key also alter the mode?
            mode.special = cEvent.data("ctrlKey");
            mode.alternative = cEvent.data("altKey");
            self.selectionModel.deleteSelection(mode);
            self.root.stopRec();
        }, "Delete selection"
    );

};
lib_core.inherit(DeleteStateMachine, lib_core.StateMachine);

module.exports = DeleteStateMachine;
